// base styles
import colors from "assets/mavric-theme/base/colors";
import typography from "assets/mavric-theme/base/typography";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { secondary, primary, text } = colors;
const { size } = typography;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "left",
      padding: `${pxToRem(5)} ${pxToRem(16)} !important`,
      backgroundColor: primary.light,
      color: text.main,
      fontSize: size.xs,

      "& .Mui-selected": {
        backgroundColor: primary.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      //display: "none",
      color: secondary.main,
    },
  },
};

export default select;
